(ns web3.icons.nav)

(def home [:svg
           {:width "29", :height "29", :view-box "0 0 29 24", :preserveAspectRatio "xMidYMid meet", :preserve-aspect-ratio "xMidYMid meet"}
           [:defs {}]
           [:g
            {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
            [:g
             {:transform "translate(-12.000000, -7.000000)"}
             [:g
              {:transform "translate(6.000000, 0.000000)"}
              [:g
               {}
               [:g
                {:transform "translate(6.000000, 7.000000)", :stroke "currentColor"}
                [:polyline {:points "0.438476562 13.3713379 14.5515137 0.668457031 28.6534424 13.3713379"}]
                [:rect
                 {:transform "translate(14.500000, 16.500000) rotate(-270.000000) translate(-14.500000, -16.500000) ",
                  :x "7",
                  :y "7",
                  :stroke "none",
                  :fill "currentColor",
                  :width "14",
                  :height "1"}]
                [:rect
                 {:transform "translate(14.500000, 16.500000) rotate(-270.000000) translate(-14.500000, -16.500000) ",
                  :x "0",
                  :y "9",
                  :stroke "none",
                  :fill "currentColor",
                  :width "5",
                  :height "1"}]
                [:rect
                 {:transform "translate(14.500000, 16.500000) rotate(-270.000000) translate(-14.500000, -16.500000) ",
                  :x "7",
                  :y "25",
                  :stroke "none",
                  :fill "currentColor",
                  :width "14",
                  :height "1"}]
                [:rect
                 {:transform "translate(14.500000, 16.500000) rotate(-270.000000) translate(-14.500000, -16.500000) ",
                  :x "21",
                  :y "7",
                  :stroke "none",
                  :fill "currentColor",
                  :width "1",
                  :height "19"}]]]]]]])

(def ask [:svg
          {:width "29",
           :height "29",
           :preserveAspectRatio "xMidYMid meet",
           :view-box "0 0 23 24",
           :preserve-aspect-ratio "xMidYMid meet"}
          [:defs {}]
          [:g
           {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
           [:g
            {:transform "translate(-14.000000, -8.000000)"}
            [:g
             {:transform "translate(6.000000, 0.000000)"}
             [:g
              {}
              [:rect {:x "0", :y "0", :width "40", :height "40"}]
              [:path
               {:d "M19.5,30.5 C21.134,30.5 22.694,30.154 24.141,29.471 L29.835,31.472 C29.888,31.491 29.944,31.5 30,31.5 C30.003,31.5 30.007,31.5 30.01,31.5 C30.289,31.502 30.52,31.28 30.52,31 C30.52,30.893 30.486,30.793 30.429,30.712 L28.637,25.614 C29.856,23.802 30.5,21.693 30.5,19.5 C30.5,13.435 25.565,8.5 19.5,8.5 C13.435,8.5 8.5,13.435 8.5,19.5 C8.5,25.565 13.435,30.5 19.5,30.5 Z M19.5,9.5 C25.014,9.5 29.5,13.986 29.5,19.5 C29.5,21.572 28.868,23.561 27.672,25.251 C27.578,25.383 27.555,25.553 27.609,25.706 L29.183,30.183 L24.276,28.459 C24.222,28.44 24.167,28.431 24.11,28.431 C24.034,28.431 23.958,28.449 23.888,28.483 C22.527,29.158 21.051,29.5 19.5,29.5 C13.986,29.5 9.5,25.014 9.5,19.5 C9.5,13.986 13.986,9.5 19.5,9.5 Z",

                :fill "currentColor",
                :fill-rule "nonzero"}]
              [:path
               {:d "M19.200675,24.8992989 C19.3635728,24.7345911 19.6465007,24.7345911 19.8008249,24.8992989 C19.8865606,24.9773184 19.9294285,25.0900133 19.9294285,25.2027081 C19.9294285,25.3154029 19.8865606,25.4280977 19.8093985,25.5061172 C19.7236628,25.5928056 19.6122064,25.6361497 19.5007499,25.6361497 C19.3892935,25.6361497 19.2864107,25.5928056 19.200675,25.5147861 C19.1149392,25.4280977 19.0720714,25.3154029 19.0720714,25.2027081 C19.0720714,25.0900133 19.1149392,24.9773184 19.200675,24.8992989 Z M16.8986711,17.5923396 C16.6620405,17.5758688 16.4845676,17.3686837 16.5008574,17.1302908 C16.6140285,15.494482 18.0526738,14.2583064 19.7022289,14.3736019 C20.5012857,14.4290824 21.231754,14.788839 21.7581712,15.3861216 C22.2880179,15.9868717 22.5486545,16.7549303 22.4937836,17.5498623 C22.4183362,18.6352002 21.8524805,19.0929146 21.3046293,19.5358919 C20.5492977,20.1453109 19.7699601,20.7764019 19.8702709,23.4524707 C19.8797018,23.6917305 19.69537,23.9023831 19.4587394,23.9023831 C19.4527379,23.9023831 19.4467364,23.9023831 19.4415923,23.9023831 C19.212678,23.9023831 19.0223447,23.7194708 19.0137711,23.4854123 C18.8963132,20.3733012 19.9345726,19.5332913 20.7687811,18.8588561 C21.2626188,18.4600898 21.5892719,18.1956903 21.6381412,17.4900473 C21.6775797,16.9300407 21.4932479,16.3882387 21.1185828,15.9643327 C20.7413457,15.5369593 20.2175005,15.2794949 19.6430712,15.2396183 C18.4650625,15.1433942 17.436234,16.0310827 17.3564998,17.1901057 C17.3393527,17.4284986 17.1267281,17.5975409 16.8986711,17.5923396 Z",
                :fill "currentColor",
                :fill-rule "nonzero"}]]]]]])

(def file [:svg
           {:width "26", :height "26", :preserveAspectRatio "xMidYMid meet", :view-box "2 0 14 23", :preserve-aspect-ratio "xMidYMid meet"}
           [:defs {}]
           [:g
            {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
            [:g
             {:transform "translate(-17.000000, -8.000000)"}
             [:g
              {:transform "translate(6.000000, 0.000000)"}
              [:g
               {}
               [:rect {:x "0", :y "0", :width "40", :height "40"}]
               [:g
                {:transform "translate(11.000000, 8.000000)"}
                [:path
                 {:d "M17.9950562,21.4213135 L17.9950562,7.78074326 C17.9982458,7.74694696 17.9982458,7.71292538 17.9950562,7.67912908 C17.9853149,7.63248733 17.9694515,7.58733772 17.9478781,7.54485319 C17.9241602,7.47339562 17.8948672,7.43433827 17.8607803,7.39969007 L10.5881079,0.159679433 C10.5534884,0.125559159 10.5144264,0.0962626082 10.4719774,0.0725815603 C10.4018697,0.042118765 10.3566546,0.0176781729 10.3086689,0 L10.2070547,0 L1.58227801,0 C0.70982528,-2.2947718e-06 0.00200103838,0.706198497 0,1.57864894 L0,21.4213135 C0.00399981074,22.2957678 0.715074984,23.0019726 1.58953617,22.9999624 L16.40552,22.9999624 C16.8260869,23.0028629 17.230425,22.8378228 17.528838,22.5414538 C17.827251,22.2450847 17.9950662,21.8418904 17.9950562,21.4213135 Z M11,2 L16,6.99988738 L11.4646465,6.99988738 C11.342353,7.00261113 11.2241256,6.95583093 11.1366845,6.87011949 C11.0492434,6.78440805 10.9999698,6.66700056 11,6.54443205 L11,2 Z M1,21.4188485 L1,1.49200398 C1.00203491,1.21968922 1.22695582,0.999992638 1.5037037,1 L10,1 L10,6.68173483 C10,7.55729734 10.3938383,8 11.2836304,8 C11.8768251,8 13.7822816,8 17,8 L17,21.4188485 C17,21.6905748 16.7761424,21.99999 16.5,21.99999 L1.51111111,21.99999 C1.23230434,22.0020218 1.00406264,21.693175 1,21.4188485 Z",
                  :fill "currentColor",
                  :fill-rule "nonzero"}]
                [:path {:d "M4,18.5 L14,18.5", :stroke "currentColor", :stroke-linecap "round"}]
                [:path {:d "M4,15.5 L14,15.5", :stroke "currentColor", :stroke-linecap "round"}]
                [:path {:d "M4,12.5 L14,12.5", :stroke "currentColor", :stroke-linecap "round"}]]]]]]])

(def menu
  [:svg
   {:width "24px", :height "16px", :preserve-aspect-ratio "xMidYMid meet", :view-box "0 0 24 16"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-14.000000, -12.000000)"}
     [:g
      {:transform "translate(6.000000, 0.000000)"}
      [:g
       {}
       [:rect {:x "0", :y "0", :width "40", :height "40"}]
       [:path {:d "M9,20 L26,20", :stroke "currentColor", :stroke-width "2", :stroke-linecap "round"}]
       [:path {:d "M9,27 L21,27", :stroke "currentColor", :stroke-width "2", :stroke-linecap "round"}]
       [:path {:d "M9,13 L31,13", :stroke "currentColor", :stroke-width "2", :stroke-linecap "round"}]]]]]])

(def account
  [:svg
   {:width "29", :height "29", :view-box "0 0 24 24", :preserveAspectRatio "xMidYMid meet", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-8.000000, -8.000000)", :stroke "currentColor"}
     [:g
      {}
      [:g
       {:transform "translate(8.000000, 8.000000)"}
       [:path
        {:d "M23.4059406,12 C23.4059406,18.2992729 18.2992729,23.4059406 12,23.4059406 C5.70072713,23.4059406 0.594059406,18.2992729 0.594059406,12 C0.594059406,5.70072713 5.70072713,0.594059406 12,0.594059406 C18.2992729,0.594059406 23.4059406,5.70072713 23.4059406,12 Z"}]
       [:path
        {:d "M15.5358416,7.49465347 C15.5358416,9.3843897 14.0037956,10.9164356 12.1140594,10.9164356 C10.2243232,10.9164356 8.69227723,9.3843897 8.69227723,7.49465347 C8.69227723,5.60491723 10.2243232,4.07287129 12.1140594,4.07287129 C14.0037956,4.07287129 15.5358416,5.60491723 15.5358416,7.49465347 Z"}]
       [:path
        {:d "M12,13.1976238 C8.51502891,13.1976238 5.63023842,14.2743446 5.12335842,16.3919715 C5.03918257,16.7441869 5.1377299,17.1173893 5.36630495,17.3979754 C6.9348499,19.3235263 9.32302574,20.5544554 12,20.5544554 C14.6769743,20.5544554 17.0651501,19.3235263 18.6334669,17.3979754 C18.8622701,17.1173893 18.9608174,16.7441869 18.8766416,16.3919715 C18.3699897,14.2743446 15.4849711,13.1976238 12,13.1976238 Z"}]]]]]])

(def service-providers
  [:svg
   {:y "0px", , :x "0px" :width "26", :height "26" :preserve-aspect-ratio "xMidYMid meet", :view-box "0 0 26 26"}
   [:style {:type "text/css"} " .st0{fill:none;} .st1{fill:none;stroke:currentColor;} "]
   [:g
    [:path {:class "st1", :d "M21.4,22.5H1.5c-0.6,0-1-0.5-1-1V1.5c0-0.6,0.5-1,1-1h19.9c0.6,0,1,0.5,1,1v19.9 C22.5,22,22,22.5,21.4,22.5z"}]
    [:path {:class "st1", :d "M16.7,7.1c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7S16.7,5.6,16.7,7.1z"}]
    [:path
     {:class "st1",
      :d "M17.4,18.6h-6.9c-0.4,0-0.7-0.3-0.7-0.7v-2.5c0-1.9,1.6-3.5,3.5-3.5h1.2c1.9,0,3.5,1.6,3.5,3.5 v2.5C18.1,18.3,17.8,18.6,17.4,18.6z"}]
    [:path {:class "st1", :d "M5.6,0.5v22"}]]])

(def pro-dashboard
  [:svg
   {:width "23px", :height "23px", :view-box "0 0 23 23", :preserve-aspect-ratio "xMidYMid meet"}
   [:title {} "Group 16"]
   [:defs
    {}
    [:polygon {:points "2.875e-05 0.000115 22.9960038 0.000115 22.9960038 23 2.875e-05 23"}]
    [:polygon {:points "0 23 23 23 23 0 0 0"}]]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-33.000000, -25.000000)"}
     [:g
      {:transform "translate(33.000000, 25.000000)"}
      [:g
       {}
       [:mask {:fill "white"} [:use {:xlinkHref "#path-1"}]]
       [:g {}]
       [:path
        {:d "M4.30792875,19.1674525 C6.22440375,17.3475775 8.81276625,16.2930275 11.4942788,16.2930275 C14.1755038,16.2930275 16.7641538,17.3435525 18.6803413,19.1674525 C16.7641538,20.9867525 14.2721038,22.0418775 11.4942788,22.0418775 C8.71616625,22.0418775 6.13154125,20.9867525 4.30792875,19.1674525 M11.4980163,0.9583525 C17.3437538,0.9583525 22.0377663,5.6526525 22.0377663,11.4981025 C22.0377663,14.1833525 20.9872413,16.57449 19.3528038,18.4952775 C17.2431288,16.4862275 14.4653038,15.33479 11.4942788,15.33479 C8.52325375,15.33479 5.74140375,16.4862275 3.63172875,18.4952775 C2.00879125,16.5828275 0.95424125,14.1833525 0.95424125,11.4981025 C0.95797875,5.65639 5.65227875,0.9583525 11.4980163,0.9583525 M11.4980163,0.000115 C5.17330375,0.000115 2.875e-05,5.177415 2.875e-05,11.4981025 C2.875e-05,17.81879 5.17330375,23.000115 11.4980163,23.000115 C17.8230163,23.000115 22.9960038,17.8225275 22.9960038,11.5021275 C22.9960038,5.1811525 17.8227288,0.000115 11.4980163,0.000115",
         :fill "currentColor",
         :mask "url(#mask-2)"}]]
      [:polygon {:fill "currentColor", :points "12 12.2664435 19.2664435 5 20 5.73386783 12.7338678 13"}]
      [:path
       {:d "M12,2 C12.5520481,2 13,2.4475761 13,3 C13,3.5524239 12.5520481,4 12,4 C11.4475761,4 11,3.5524239 11,3 C11,2.4475761 11.4475761,2 12,2",
        :fill "currentColor"}]
      [:path
       {:d "M3,11 C3.5524239,11 4,11.4475761 4,12 C4,12.5524239 3.5524239,13 3,13 C2.4479519,13 2,12.5524239 2,12 C2,11.4475761 2.4479519,11 3,11",
        :fill "currentColor"}]
      [:path
       {:d "M19.9998121,11 C20.5523398,11 21,11.4475761 21,12 C21,12.5524239 20.5523398,13 19.9998121,13 C19.4476602,13 19,12.5524239 19,12 C19,11.4475761 19.4476602,11 19.9998121,11",
        :fill "currentColor"}]
      [:path
       {:d "M6.06229206,7 C6.32340871,7 6.57947398,6.86753074 6.7100323,6.73506148 C7.0966559,6.342779 7.0966559,5.68595226 6.7100323,5.29406403 C6.32340871,4.90217581 5.67605703,4.90178155 5.289822,5.29406403 C4.90358697,5.68634651 4.90319841,6.34317326 5.289822,6.73506148 C5.54511015,6.86753074 5.80117542,7 6.06229206,7",
        :fill "currentColor"}]
      [:mask {:fill "currentColor"} [:use {:xlinkHref "#path-3"}]]
      [:g {}]
      [:polygon {:fill "currentColor", :mask "url(#mask-4)", :points "10 20 14 20 14 19 10 19"}]]]]])

(def share
  [:svg
   {:width "19px",
    :height "24px",
    :view-box "0 0 19 24",
    :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none",
     :stroke-width "1",
     :fill "none",
     :fill-rule "evenodd"}
    [:g
     {:transform "translate(-27.000000, -8.000000)",
      :fill "currentColor",
      :fill-rule "nonzero",
      :stroke "currentColor",
      :stroke-width "0.25"}
     [:g
      {:transform "translate(28.000000, 9.000000)"}
      [:path
       {:d
        "M5.20536219,4.26067523 L8.09948483,1.36701446 L8.09948483,15.2824796 C8.09948483,15.5035083 8.27891562,15.6828939 8.5,15.6828939 C8.72108438,15.6828939 8.90051517,15.5035083 8.90051517,15.2824796 L8.90051517,1.36701446 L11.7946378,4.26067523 C11.8728718,4.3388895 11.9754037,4.37786316 12.0779355,4.37786316 C12.1804674,4.37786316 12.2829993,4.3388895 12.3612333,4.26067523 C12.5177012,4.10424671 12.5177012,3.85091792 12.3612333,3.69448939 L8.78356474,0.117454865 C8.71067098,0.0448464031 8.61054219,0 8.5,0 C8.38945781,0 8.28932902,0.0448464031 8.21670227,0.117187922 L4.63903374,3.69422245 C4.48256581,3.85065098 4.48256581,4.10397977 4.63903374,4.26040829 C4.79550166,4.41683682 5.04889426,4.41710376 5.20536219,4.26067523 Z M15.5314444,7.10645616 L11.1367249,7.10645616 C10.9156405,7.10645616 10.7362097,7.28584177 10.7362097,7.50687047 C10.7362097,7.72789917 10.9156405,7.90728478 11.1367249,7.90728478 L15.5314444,7.90728478 C15.8996513,7.90728478 16.1989697,8.20652775 16.1989697,8.57464197 L16.1989697,20.5318142 C16.1989697,20.8999284 15.8996513,21.1991714 15.5314444,21.1991714 L1.46855563,21.1991714 C1.10034868,21.1991714 0.801030345,20.8999284 0.801030345,20.5318142 L0.801030345,8.57464197 C0.801030345,8.20652775 1.10034868,7.90728478 1.46855563,7.90728478 L5.86327511,7.90728478 C6.08435949,7.90728478 6.26379029,7.72789917 6.26379029,7.50687047 C6.26379029,7.28584177 6.08435949,7.10645616 5.86327511,7.10645616 L1.46855563,7.10645616 C0.658713954,7.10645616 0,7.76500423 0,8.57464197 L0,20.5318142 C0,21.3414519 0.658713954,22 1.46855563,22 L15.5314444,22 C16.341286,22 17,21.3414519 17,20.5318142 L17,8.57464197 C17,7.76500423 16.341286,7.10645616 15.5314444,7.10645616 Z"}]]]]])